import React from 'react'
import SearchIcon from '../Icons/solid/SearchIcon'
import { COLORS } from '../../config';

function SearchInput({
  value,
  onChange,
  onKeyPress,
  placeholder,
  id
}) {
  return (
    <div id={id} className='bg-gray-200 rounded items-center flex px-2 py-2 w-full'>
      <SearchIcon fill={COLORS.colorSecondary}/>
      <input aria-label={'Input search terms'} type="text" value={value} placeholder={placeholder || 'Search'} onChange={onChange} onKeyPress={onKeyPress} className="focus:outline-none rounded bg-gray-200 text-sm leading-none text-secondary w-full pl-3" />
    </div>
  )
}

export default SearchInput
